import {Injectable} from '@angular/core';
import {ApiService} from './api.service';

@Injectable({
  providedIn: 'root'
})
export class ContactService {

  constructor(private apiService: ApiService) {}

  sendMessage(contact: any): any {
    return this.apiService.post('/contact', contact);
  }

}
